import _ from 'lodash'
import { mapKeys } from '@util/generalUtil'

const Insurer = {
  'unimed-assis': {
    id: 1, name: 'Unimed Assis', recommendationsId: 1
  },
  'cynthia-charone': {
    id: 2, name: 'Cynthia Charone', recommendationsId: 1
  },
}

const InsurerEnum = Object.freeze({
  ...Insurer,
  ...mapKeys(Insurer, (value) => value.id),
  list: _.map(_.values(Insurer), ({ id, ...rest }) => ({ value: id, ...rest })),
})

export default InsurerEnum
